import { processUrlInCaseFailOverIsRequired } from "@/utils/urlUtils";

export default {
  versions: {
    default: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/AssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
      splashScreenBackgroundColor: 0x323031
    },
    betfair: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetfairAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    betfair_esa: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetfairAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    bfarcade: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetfairAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    betfair_br: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetfairAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    ambassadoribet: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/AmbassadoribetAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    ambassadori: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/AmbassadoribetAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximan_ec: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximan_be: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximanbe: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximan_bg: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximan_pt: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximanbr: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximancl: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximande: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximan_ro: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    betano_br: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximanmx: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
    stoiximan_gr: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/StoiximanAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
      splashScreenBackgroundColor: 0x323031
    },
    stoiximan_ng: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetanoAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
      splashScreenBackgroundColor: 0x323031
    },

    betclic_pt: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetclicAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },

    betclic_ci: {
      assetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/BetclicAssetsConfig.json`),
      preloaderAssetsConfigPath: processUrlInCaseFailOverIsRequired(`${process.env.ASSETS_URL}/assets/json/preloaderAssets.json`),
    },
  },
}



